export const ASSETS_NUMBER_FOR_BENTLEY_ANALYTICS_REPORT = 1
